import { createContext } from 'react';

import { DEFAULT_LABELS_OFFSET, DEFAULT_LABELS_WIDTH } from '../constants.js';

interface AnnotationsContextProps {
  showLabels: boolean;
  labelsWidth: number;
  trackWidth: number;
}

export const AnnotationsConfigContext = createContext<AnnotationsContextProps>({
  showLabels: true,
  labelsWidth: DEFAULT_LABELS_OFFSET + DEFAULT_LABELS_WIDTH,
  trackWidth: 0,
});

AnnotationsConfigContext['displayName'] = 'AnnotationsConfig.Context';
